"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BasicError = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var _lodash = _interopRequireDefault(require("lodash"));

var BasicError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(BasicError, _Error);

  /**
   * @constructor
   */
  function BasicError(message, error, data, name) {
    var _this;

    (0, _classCallCheck2.default)(this, BasicError);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BasicError).call(this, error && error.message ? "".concat(message, " <- ").concat(error.message) : message));

    if (error) {
      if (_lodash.default.isError(error)) _this.cause = function () {
        return error;
      };else data = error;
    }

    if (data) _lodash.default.merge((0, _assertThisInitialized2.default)(_this), _lodash.default.isObject(data) ? data : {
      data: data
    });
    _this.name = name || _lodash.default.get((0, _assertThisInitialized2.default)(_this), ['__proto__', 'constructor', 'name']) || 'Error';
    return _this;
  }

  (0, _createClass2.default)(BasicError, [{
    key: "fullStack",
    get: function get() {
      var stack = this.stack;

      try {
        var cause = this.cause;

        while (_lodash.default.isFunction(cause)) {
          var error = cause();
          if (!error) break;
          stack = "".concat(stack, "\n...caused by ").concat(error.stack ? error.stack : JSON.stringify(error));
          cause = error.cause;
        }
      } catch (error) {
        stack = "".concat(stack, "\n\n...full stack failed ").concat(error.stack);
      }

      return stack;
    }
  }]);
  return BasicError;
}((0, _wrapNativeSuper2.default)(Error));

exports.BasicError = BasicError;
var _default = BasicError;
exports.default = _default;